<template>
    <div class="layoutPadding mt-2 d-flex">
        <div class="col-md-3 pl-0" style="padding-right: 20px">
            <spv-dashboard-profile-card 
                :stageInvested="stageInvested"
                :lastFundingRound="portfolioData && portfolioData.stage ? portfolioData.stage : '-'"
                :location="location"
                :tags="tags.join(', ')"
            ></spv-dashboard-profile-card>
        </div>
        <div class="col-md-9 pl-0 pr-0" >
            <div class="card" style="padding: 20px">
                <p class="spv_info_heading">SPV Information</p>
                <div class="col-12" style="padding-left: 0">
                    <div class="col-12 d-flex" style="padding-left: 0" >
                        <div class="col-4" style="padding-left: 0" >
                            <p class="infoLabel" >Investment Amount</p>
                            <p class="value" >{{investmentAmounts? `$${investmentAmounts}`: "-"}}</p>
                        </div>
                        <div class="col-4" style="padding-left: 0" >
                            <p class="infoLabel" >Value Of Investment</p>
                            <p class="value" >{{valueOfInvestments ? `$${valueOfInvestments}`: "-"}}</p>
                        </div>
                        <div class="col-4" style="padding-left: 0" >
                            <p class="infoLabel">MOIC</p>
                            <p class="value">{{moic}}</p>
                        </div>
                    </div>
                    <div class="spv_desc">
                        {{description}}
                    </div>
                </div>
            </div>
            <div class="row w-100 ml-0 mr-0 mb-10" >
                <!-- <div class="col-12"> -->
                    <div class="col-6" style="margin-top: 10px">
                        <chartjs-doughnut-card v-if="showChart" :text="doughnutText"
                            :chart-data="chartData"
                            :chart-options="chartOptions"
                        >
                        <template v-slot:header>
                            <p style="font-weight: 500">SPV</p>
                        </template>
                        </chartjs-doughnut-card>
                    </div>
                    <div class="col-6" style="margin-top: 10px">
                        <chartjs-bar-card v-if="showChart" :text="doughnutText"
                            :chart-data="barChartData"
                            :chart-options="barChartOptions"
                        >
                        <template v-slot:header>
                            <div class="barChartHeader">
                                <p style="font-weight: 500">SPV</p>
                                <div class="barChartHeader_details">
                                    <p>Ownership :{{portfolioData && portfolioData.ownership ?  `${portfolioData.ownership}%` : " -"}}</p>
                                    <p>Total Value : ${{valueOfInvestments ? valueOfInvestments : " -"}}</p>
                                </div>
                            </div>
                        </template>
                        </chartjs-bar-card>
                    </div>
                <!-- </div> -->
            </div>
            <div class="col-12" style="padding: 0 0">
                <notes-card-spv></notes-card-spv>
            </div>
            <div class="col-12" style="padding: 0 0" >
                <div v-if="portfolios.length<1" class="card col-12 d-flex flex-row-reverse" style="padding:20px" >
                    <button type="button" 
                        class="todo-form-submit-button btn btn-primary"
                        style="background: #5445F3; border: none; outline: none; width: 150px"
                        @click="handleAddCompany">
                            <i class="fa fa-plus" aria-hidden="true"></i> Add Company
                    </button>
                </div>
                <div v-else class="card">
                    <div class="col-12 d-flex" style="padding-top: 10px; padding-bottom: 20px">
                        <div class="col-6" style="padding-left: 0">
                            <div class="col-12 d-flex" style="padding-left: 0" >
                                <div class="col-4" style="padding-left: 0" >
                                    <div class="flex-grow-1" style="text-align: center">
                                        <img
                                            :src="image"
                                            class="rounded-circle"
                                            style="width: 120px; height: 120px"
                                        />
                                    </div>
                                </div>
                                <div class="col-8" style="padding-left: 0; padding-top: 10px" >
                                    <p style="font-size: 16px; margin: 0">
                                        {{portfolioData.name}}
                                    </p>
                                    <p class="category_data">
                                        {{portfolioData.category_data}}
                                    </p>
                                    <p class="portfolio_desc">
                                        {{portfolioData.description.length>100 ? (this.portfolioData.description).substring(0,100) + "..." : this.portfolioData.description}}
                                    </p>
                                </div>
                            </div>
                            <div class="col-12 d-flex" style="padding-left: 0; padding-top: 10px" >
                                <div class="col-4" style="padding-left: 14px" >
                                    <p class="portfolioData_label">Website</p>
                                </div>
                                <div class="col-8" style="padding-left: 0;" >
                                    <p class="website_link"><a :href="portfolioData.website" >{{portfolioData.website}}</a></p>
                                </div>
                            </div>
                            <div class="col-12 d-flex" style="padding-left: 0; padding-top: 10px" >
                                <div class="col-4" style="padding-left: 14px" >
                                    <p class="portfolioData_label">Contact Email</p>
                                </div>
                                <div class="col-8" style="padding-left: 0;" >
                                    <p style="font-size:14px; color: #0000009A">{{portfolioData.contact_email}}</p>
                                </div>
                            </div>
                            <div class="col-12 d-flex" style="padding-left: 0; padding-top: 10px" >
                                <div class="col-4" style="padding-left: 14px" >
                                    <p class="portfolioData_label">Social Media</p>
                                </div>
                                <div class="col-8 d-flex" style="padding-left: 0;" >
                                    <a class="link" :href="portfolioData.facebook" target="_blank" style="color: #0000009A;font-size: 18px;padding-right: 5px;">
                                        <i class="fa fa-facebook-square" aria-hidden="true"></i>
                                    </a>
                                    <a class="link" :href="portfolioData.linkedin" target="_blank" style="color: #0000009A;font-size: 18px;padding-right: 5px;">
                                        <i class="fa fa-linkedin-square" aria-hidden="true"></i>
                                    </a>
                                    <a class="link" :href="portfolioData.twitter" target="_blank" style="color: #0000009A;font-size: 18px;padding-right: 5px;">
                                        <i class="fa fa-twitter-square" aria-hidden="true"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="col-12 d-flex" style="padding-left: 0; padding-top: 10px" >
                                <div class="col-4" style="padding-left: 14px" >
                                    <p class="portfolioData_label">Founders</p>
                                </div>
                                <div class="col-8" style="padding-left: 0;" >
                                    <div class="founders_grid">
                                        <div v-for="item in people.founders" class="d-flex align-items-center" :key="item._id">
                                            <img :src="foundersImage(item)" width="20" height="20" class="rounded-circle">
                                            <p style="margin: 0 0 0 10px; font-size: 12px" >{{item.name}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6" style="padding-left: 0; padding-top: 15px">
                            <div class="col-12 d-flex" style="padding-left: 0" >
                                <div class="col-6" style="padding-left: 0;padding-right: 10px; padding-top: 10px; border-right: 1px solid #757575">
                                    <div class="col-12 investmentStatus" style="padding-left: 0">
                                        <div >Investment Value</div>
                                        <div >{{investmentAmounts ? `$${investmentAmounts}`: "-"}}</div>
                                    </div>
                                    <div class="col-12 investmentStatus" style="padding-left: 0">
                                        <div >Valuation</div>
                                        <div >{{investmentAmounts && moic ? `$${investmentAmounts * moic}`: "-"}}</div>
                                    </div>
                                    <div class="col-12 investmentStatus" style="padding-left: 0">
                                        <div>Ownership </div>
                                        <div>{{portfolioData.ownership ? `${portfolioData.ownership}%` : "-"}}</div>
                                    </div>
                                </div>
                                <div class="col-6" >
                                    <div class="col-12 investmentStatus" style="padding-left: 0">
                                        <div >Amount raised to date</div>
                                        <div >{{(valueOfInvestments && investmentAmounts)? `$${valueOfInvestments - investmentAmounts}` : "-"}}</div>
                                    </div>
                                    <div class="col-12 investmentStatus" style="padding-left: 0">
                                        <div >Current Value</div>
                                        <div >{{valueOfInvestments ? `$${valueOfInvestments}`: "-"}}</div>
                                    </div>
                                    <div class="col-12 investmentStatus" style="padding-left: 0">
                                        <div>Last Funding Round</div>
                                        <div>{{portfolioData.stage ? portfolioData.stage : "-"}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" style="padding-left: 0; margin-top: 10px">
                                <spv-news-feed-card
                                    :newsFeedList="newsFeedList"
                                    context="Profile"
                                ></spv-news-feed-card>
                                <div class="d-flex justify-content-end">
                                    <p @click="handleMoreInfoClick" class="moreInfo">More info</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <spv-add-company @getPortfolios="getPortfolios" :value="addCompanyProps"></spv-add-company>
    </div>
</template>
<script>
import SPVDashboardProfileCard from '../../../components/Cards/SPVDashboardProfileCard.vue';
import NotesCardSPV from '../../../components/Cards/NotesCardSPV.vue';
import SPVNewsFeedCard from '../../../components/Cards/SPVNewsFeedCard.vue';
import SPVAddCompany from '../Dialogs/SPVAddCompany.vue';
import ChartjsDoughnutCard from '../../../components/Cards/Chartjs/ChartjsDoughnutCard.vue';
import ChartjsBarCard from '../../../components/Cards/Chartjs/ChartjsBarCard.vue';
import api from "../../../axios_api";
import config from '../../../../config/settings';
import { mapGetters } from "vuex";
export default {
    name: "spv-dashboard",
    components: {
        [SPVDashboardProfileCard.name]: SPVDashboardProfileCard,
        [NotesCardSPV.name]: NotesCardSPV,
        [SPVAddCompany.name]: SPVAddCompany,
        [SPVNewsFeedCard.name]: SPVNewsFeedCard,
        [ChartjsDoughnutCard.name]: ChartjsDoughnutCard,
        [ChartjsBarCard.name]: ChartjsBarCard
    },
    data(){
        return {
            doughnutText:"",
            addCompanyProps : {
                isShow: false,
                data: {},
            },
            portfolios: [],
            dashboardDescription: "",
            portfolioData: null,
            peopleData: [],
            newsFeedList: [],
            lastFundingRound: "-",
            location: "-",
            tags: [],
            showChart: false,
            spvfundSize: 0,
            syndicateDetailsData: [],
            pieChartData: [],
            barChartLabels: [],
            barChartCostData : [],
            barChartValueData : []
        }
    },
    computed: {
        ...mapGetters("investment", ["investments"]),
        barChartOptions(){
            // let d = self.chartData
            let options = {
                maintainAspectRatio: false,
                responsive: true,
                legend:{
                        position: "bottom",
                        align: "center",
                        labels: {
                        boxWidth: 14,
                        fontSize: 14,
                        fontColor: "#000",
                        fontFamily: "custom-helvetica,roboto"
                        }
                    },
                tooltips: {
                    displayColors: false,
					enabled: true,
					mode: 'single',
					callbacks: {
						label: function(tooltipItems, data) {
                            let index=-1;
                            for(let i=0; i<data.labels.length; i++){
                                if(data.labels[i] === tooltipItems.xLabel){
                                    index = i;
                                };
                            }
                            let cost=data.datasets[0].data[index]
                            let value=data.datasets[1].data[index]
                            let profit=((value-cost)/cost)*100;
                            return [`cost: $${cost}`,`value: $${value}`,`profit: ${profit.toFixed(2)}%`]
						},
					}
				}
            };
            return options;
        },
        barChartData(){
            let data={
                labels: this.barChartLabels,
                datasets: [{
                    label: 'Cost',
                    data: this.barChartCostData,
                    backgroundColor: "#006BFD",
                    barPercentage: 1.0,
                    categoryPercentage: 1.0
                },
                {
                    label: 'Value',
                    data: this.barChartValueData,
                    backgroundColor: "#2EB7FF",
                    barPercentage: 1.0,
                }]
            }
            return data;
        },
        chartOptions() {
            // let d = self.chartData
            let options = {
                maintainAspectRatio: false,
                responsive: true,
                legend:{
                        position: "bottom",
                        align: "center",
                        labels: {
                        boxWidth: 14,
                        fontSize: 14,
                        fontColor: "#000",
                        fontFamily: "custom-helvetica,roboto"
                        }
                    },
            };
            return options;
        },
        chartData() {
            let data={
                labels: ['Pending', 'Commited'],
                datasets: [{
                    label: '',
                    data: this.pieChartData,
                    backgroundColor: [
                        '#9358A2',
                        '#6D5BA4',
                    ],
                    borderColor: [
                        '#fff',
                        '#fff',
                    ],
                    borderWidth: 1
                }]
            }
            return data;
        },
        description(){
            if(this.portfolios.length>0){
                return this.portfolios[0].description
            }else{
                return ""
            }
        },
        investmentAmounts(){
            if(this.investments.length>0){
                let cost = 0;
                for(let item of this.investments){
                    if(item.amount){
                        cost += parseInt(item.amount);
                    }
                }
                return cost;
            }
            return null
        },
        valueOfInvestments(){
            if(this.investments.length>0){
                let value = 0;
                for(let item of this.investments){
                    if(item.currentValue){
                        value += parseInt(item.currentValue);
                    }
                }
                return value;
            }
            return null
        },
        moic(){
            if(this.investments.length > 0){
                let cost=0, value=0;
                for(let item of this.investments){
                    if(item.amount){
                        cost += parseInt(item.amount);
                    }
                    if(item.currentValue){
                        value +=parseInt(item.currentValue);
                    }
                }
                return (Number(value) / Number(cost)).toFixed(2)
            }
            return null
        },
        stageInvested(){
            if(this.investments.length>0){
                return this.investments[this.investments.length-1].offering;
            }
            return "-"
        },
        people() {
            const self = this;
            return {
                investors: _.filter(self.peopleData, function(o) {
                return (
                    o.context === "investor" &&
                    o.portfolio_item === self.portfolioData._id
                );
                }),
                employees: _.filter(self.peopleData, function(o) {
                return (
                    o.context === "employee" &&
                    o.portfolio_item === self.portfolioData._id
                );
                }),
                advisors: _.filter(self.peopleData, function(o) {
                return (
                    o.context === "advisor" &&
                    o.portfolio_item === self.portfolioData._id
                );
                }),
                founders: _.filter(self.peopleData, function(o) {
                return (
                    o.context === "founder" &&
                    o.portfolio_item === self.portfolioData._id
                );
                })
            };
        },
        image() {
            if(this.portfolioData){
                return this.portfolioData.hasOwnProperty("image_id") &&
                this.portfolioData.image_id.length > 0
                ? `${config.CRUNCHBASE_IMAGE_URL}/${this.portfolioData.image_id}`
                : _.isNil(this.portfolioData.logo_url) || _.isEmpty(this.portfolioData.logo_url)
                ? "static/img/generic-logo.png"
                : this.getImageUrl(this.portfolioData.logo_url);
            }else{
                return "static/img/generic-logo.png"
            }
        },
    },
    methods: {
        handleAddCompany(){
            this.addCompanyProps={
                isShow: true,
                data: {}
            }
        },
        handleMoreInfoClick(){
            this.$store.commit("temp/currentCompany", this.portfolioData.ucid);
            this.$router.push(
              `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/spvCompanyProfile/${this.portfolioData.ucid}`
            );
        },
        getPortfolios(){
            const self = this;
            api.get(`/${this.$route.params.account_id}/${this.$route.params.workspace_id}/portfolio`).then(res => {
                self.portfolios = res.data.encrypt.data;
                console.log("data : ", res.data.encrypt.data);
                if(self.portfolios.length>0){
                    self.portfolioData = self.portfolios[0];
                    if(self.portfolioData){
                        self.location = self.portfolioData.geography;
                        self.tags = self.portfolioData.tags;
                        this.getPeopleData();
                        this.getNewsFeed();
                    }
                }else{
                    self.addCompanyProps.isShow = true;
                }
            }).catch(err => {
                console.log("error fetching portfolios : ", err);
            })
        },
        getPeopleData() {
            api
                .get(`portfolio/peoples/${this.portfolioData._id}`)
                .then(data => {
                this.peopleData = data.data.encrypt.success;
                })
                .catch(err => console.log(err));
        },
        getNewsFeed(){
            let self = this;
            api
            .get(
              `/portfolio/newsFeed/${this.portfolioData.permalink}/${this.portfolioData.name}`
            )
                .then(data => {
                if (
                    data.data &&
                    data.data.encrypt &&
                    data.data.encrypt.success &&
                    data.data.encrypt.success[0] &&
                    data.data.encrypt.success[0][0]
                ) {
                    let list = [];
                    let newsList = data.data.encrypt.success[0][0];
                    if (newsList.data_cb_permalink.status) {
                    newsList.data_cb_permalink.feed.map(item => list.push(item));
                    }
                    if (newsList.data_rss_company_name.status) {
                    newsList.data_rss_company_name.feed.map(item =>
                        list.push(item)
                    );
                    }
                    self.newsFeedList = list.sort((a, b) => {
                    return new Date(b.time) - new Date(a.time);
                    });
                }
                })
                .catch(err => {
                    console.log({ err });
                });
        },
        foundersImage(item){
            return item.image_id && item.image_id.length > 0
                        ? `${config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
                        : `${
                            item.image && item.image.length > 0
                              ? item.image
                              : 'static/img/faces/face-0.jpg'
                          }`
        },
        getCurrentWorkspaceDetails(){
            const self = this;
            api.get(`/${this.$route.params.account_id}/${this.$route.params.workspace_id}/currentWorkspace`).then(res => {
                const data = res.data.encrypt.success;
                self.spvfundSize = data.targetAllocationAmount;
                self.doughnutText=data.targetAllocationAmount;
                self.getSyndicateData();
            }).catch(err => {
                console.log("error getting current workspace : ", err);
            })
        },
        async getSyndicateData(){
            try{
                const data = await api.get(`/${this.$route.params.account_id}/${this.$route.params.workspace_id}/syndicateDetails`);
                const details = data.data.encrypt.success;
                this.syndicateDetailsData = details;
                let commited = 0;
                let barChartLabels = [];
                for(let item of details){
                    barChartLabels.push(item.entity_name);
                    if(item.status === "Commited"){
                        commited += parseInt(item.capital_commitment);
                    }else if(item.status === "Wired"){
                        commited += parseInt(item.capital_commitment);
                    }else if(item.status === "Signed & Wired"){
                        commited += parseInt(item.capital_commitment);
                    }else if(item.status === "Co-signed"){
                        commited += parseInt(item.capital_commitment);
                    }
                }
                let pending = this.spvfundSize - commited;
                this.barChartLabels = barChartLabels;
                this.pieChartData = [pending, commited];
                this.createBarChartData();
            }catch(error){
                console.log("Error getting syndicate data : ",error);
            }
        },
        createBarChartData(){
            let cost=[], value=[], totalCost=0, totalValue=0;
            if(this.investments.length>0){
                for(let item of this.investments){
                if(item.amount){
                    totalCost += parseInt(item.amount);
                }
                if(item.currentValue){
                    totalValue +=parseInt(item.currentValue);
                }
                }
                for(let item of this.syndicateDetailsData){
                    if(item.ownership*totalCost/100 > item.capital_commitment){
                        cost.push(item.capital_commitment);
                    }else{
                        cost.push(item.ownership*totalCost/100);
                    }
                    value.push(item.ownership*totalValue/100);
                }
                this.barChartCostData=cost;
                this.barChartValueData=value;
            }
        },
        getImageUrl(image) {
            if (!image) {
                return;
            }
            // image.includes(
            //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
            //) ||
            if (
                image.includes(config.CRUNCHBASE_IMAGE_URL) ||
                image.includes("https://res") ||
                image.includes("static/img/generic-logo.png")
            ) {
                return image;
            }
            let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
            if (!imageId || imageId.length == 0) {
                return image;
            }
            return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
        },
    },
    mounted() {
        setTimeout(() => {
            this.showChart = true;
        },1500)
        this.getCurrentWorkspaceDetails();
        this.getPortfolios();
    }
}
</script>
<style lang="scss" scoped>
    .spv_info_heading{
        color: #5A5D71;
        margin-bottom: 20px;
    }
    .infoLabel{
        color: #757575;
        font-size: 14px;
        margin-bottom: 0;
    }
    .value{
        font-size: 30px;
        font-weight: 500;
    }
    .spv_desc{
        font-size: 12px;
        color: #30334C;
        font-weight: 600;
    }
    .category_data{
        font-size: 12px;
        color: #000000B2;
        margin: 5px 0 0 0;
        font-weight: 600;
    }
    .portfolio_desc{
        font-size: 12px;
        color: #757575;
        margin: 5px 0 0 0;
        font-weight: 300;
    }
    .portfolioData_label{
        font-size: 14px;
        font-weight: 600;
    }
    .website_link{
        font-size: 14px;
        margin: 0
    }
    .founders_grid{
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 5px;
    }
    .investmentStatus{
        font-size: 14px;
        color: #757575;
        margin-bottom: 10px;
        display: grid;
        grid-template-columns: 2.5fr 1fr;
    }
    .moreInfo{
        color: #5445F3;
        font-size: 14px;
        text-decoration: underline;
        cursor: pointer;
        margin-top: 5px;
    }
    .barChartHeader{
        display: flex;
        align-items: center;
        &_details{
            margin-left: 5px;
            border-left: 1px solid #707070;
            padding-left: 20px;
            p{
                margin: 0;
                font-size: 12px;
                font-weight: 500;
            }
        }
        p{
            padding-right: 10px;
            font-weight: 500;
            margin: 0;
        }
    }
</style>